import PriceText from '../PriceText/index.vue';

export default {
  name: 'SalesKicker',
  props: {
    savings: {
      type: String,
      default: '',
    },
    saveText: {
      type: String,
      default: '',
    },
  },
  components: {
    PriceText,
  },
};
